// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"featuredchannellist_wrapper__NIr_1","threeColumnsAtLg":"featuredchannellist_threeColumnsAtLg__EkFxv"};